'use strict';

exports.__esModule = true;
// This is an example of the actions for a component that the page will compose.
// It should export string constants for its action types (with a prefix e.g. SEARCH_BAR:GET_LOCATIONS)
// and use those in the action methods (e.g. getLocationAutocomplete).

// Things with API calls will use createAction as commented out below. See doctify/home-page.

// import { createAction } from 'doctify-utils';

var ON_TAB_SELECTED = exports.ON_TAB_SELECTED = 'HEADER_ACTIONS:ON_TAB_SELECTED';

var headerActions = exports.headerActions = {
	onTabSelected: function onTabSelected(tab) {
		return {
			type: ON_TAB_SELECTED,
			tab: tab
		};
	}
};